import {writable} from 'svelte/store';
import Helper from '../Models/Helper';

const content = {list: [], back: {}, front: {}, zoomed: false, shrunken: false, loaded: false, timeout_1: 0, timeout_2: 0};
const gallery = writable(content);

gallery.render = data => {
	const item = {type: 'render', large: data, small: data};
	if (content.list.length && (content.list[0].type == 'render'))
		content.list[0] = item;
	else content.list.unshift(item);
	gallery.active(item);
};

gallery.option = (type, small, large) => {
	const item = {type, small, large};
	const index = content.list.findIndex(option => option.type == type);
	if (index === -1) content.list.push(item);
	else content.list[index] = item;
};

gallery.commit = () => {
	gallery.set(content);
};

gallery.active = item => {
	for (const image of content.list) image.active = false;
	item.active = true;

	content.back = content.front;
	gallery.set(content);

	const step_1 = () => {
		content.front = item;
		content.front.instant = true;
		content.front.show = false;
		gallery.set(content);
	};

	const step_2 = () => {
		content.front.instant = false;
		content.front.show = true;
		gallery.set(content);
	};

	clearTimeout(content.timeout_1);
	content.timeout_1 = setTimeout(step_1, 30); /* These timings are OK if you don't have the inspector open. */

	clearTimeout(content.timeout_2);
	content.timeout_2 = setTimeout(step_2, 40);
};

gallery.zoom = () => {
	content.zoomed = !content.zoomed;
	gallery.set(content);
};

gallery.shrink = () => {
	content.shrunken = !content.shrunken;
	gallery.set(content);
};

export default gallery;